import React from "react";
import Image from "next/image";

const VendorBanner: React.FC = () => {
  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[120px] lg:pb-[180px] xl:pb-[240px] relative z-0">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full"
            />
          </div>

          {/* Content */}
          <div className="container z-5 relative">
            <div className="blog-heading ">
              <h1 className="text-center text-white font-[800] text-display uppercase mb-[12px]">
                Vendor Registration
              </h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VendorBanner;
